import { action } from 'easy-peasy';
import { IActionAddCarePlanIntervention } from '../types';

const addCarePlanIntervention: IActionAddCarePlanIntervention = action((state, payload) => {
  state.items = [payload, ...state.items].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
  );
});

export default addCarePlanIntervention;
